/**
 * LabSek Main Frontend Script
 */


/**
 * Boostrap dependencies
 * NOTE: Popover, dropdowns and tooltip require popper and util modules. Popovers also require tooltip.
 * popper already exists
 */
//import * as Popper from "@popperjs/core"

// import { Util, Alert, Button, Collapse, Dropdown, Modal, Offcanvas, Popover, ScrollSpy, Tab, Toast, Tooltip } from 'bootstrap';
import { Dropdown, Offcanvas } from 'bootstrap'

import Lenis from '@studio-freight/lenis'
import SplitType from 'split-type'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin'

import Plyr from 'plyr';

/**
 * App modules
 */

import { Smoke } from './modules/smoke.js';
import { debounce, isMobile, goTo } from './modules/utils.js';
import './modules/anchor-scrolls.js';


(function ($, themeData) {

  'use strict';

  // Expose jquery to modules
  window.jQuery = $;
  window.$ = $;

  // Disable Video.js GA
  window.HELP_IMPROVE_VIDEOJS = false;

  // Aux constants
  const $body = $('body');
  const $win = $(window);
  const $doc = $(document);
  const $goup = $('.sticky-scroll');
  const breakpoint = 768;

  let lenis = null;
  let ww = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  let $players = null;
  let $videos = [];

  /**
   * Append external link suffix
   * @param {object} item dom element
   */
  const appendExternal = function (item) {
    var $item = $(item);
    if (!$item.find('.visually-hidden').length) {
      $item.append(`<span class="visually-hidden">${themeData.t.externalLink}</span>`);
    }
  }

  /**
   * Sum fixed elements to offset
   */
  const getOffset = function (offset) {
    const $header = $('.site-header');
    offset = offset || 0;

    if ($header.length) {
      offset += $header.height();
    }

    if ($('body').hasClass('admin-bar')) {
      offset += $('#wpadminbar').height();
    }

    return offset;
  }


  /**
   * Watch offcanvas search click outside
   */
  const offCanvasSearchWatch = function (ev) {

    const $offcanvas_instance = Offcanvas.getInstance('#offcanvas-search')

    if ($offcanvas_instance) {
      for (var n = !1, r = ev.target; r != document.body; r = r.parentNode) {
        if ("masthead" == r.id) {
          n = !0;
          break
        }
      }
      n || $offcanvas_instance.toggle();
    }

  }


  /**
   * Setup menu
   */
  const setupMenu = function () {


    /* Offcanvas menu */

    const $offcanvas_menu = $('#offcanvas-menu');

    $offcanvas_menu.on('show.bs.offcanvas', function () {
      $('.offcanvas-menu-trigger').removeClass('closed');
    });

    $offcanvas_menu.on('hide.bs.offcanvas', function () {
      $('.offcanvas-menu-trigger').addClass('closed');
    });

    /* Offcanvas search */

    const $offcanvas_search = $('#offcanvas-search');

    $offcanvas_search.on('shown.bs.offcanvas', function () {
      $offcanvas_search.find('input[name="s"]').trigger('focus');
      $doc.on("click", offCanvasSearchWatch);
    });

    $offcanvas_search.on('hide.bs.offcanvas', function () {
      $doc.off("click", offCanvasSearchWatch);
    });

    /* Header Menu Dropdowns */

    const $dropdowns = $('.site-menu .dropdown');
    $dropdowns.each(function () {
      const $toggle = $(this).find('.dropdown-toggle');
      if ($toggle.length) {
        new Dropdown($toggle[0]);
      }
    })


    $dropdowns.on('mouseenter', function (ev) {
      const $toggle = $(this).find('.dropdown-toggle');
      if ($toggle.length) {
        const toggleInstance = Dropdown.getInstance($toggle[0]);
        if (toggleInstance) {
          toggleInstance.show();
        }
      }
    })

    $dropdowns.on('mouseleave', function (ev) {
      const $toggle = $(this).find('.dropdown-toggle');
      if ($toggle.length) {
        const toggleInstance = Dropdown.getInstance($toggle[0]);
        if (toggleInstance) {
          toggleInstance.hide();
          $toggle.blur();
        }
      }
    })

    // External links
    /*const $external = $( '.site-menu ul.navbar-nav a[target=_blank], ul.footer-list a[target=_blank], ul.footer-text a[target=_blank]' );
    $external.each( function () {
      appendExternal( this );
    } )*/

  }


  /**
   * Setup generic events
   */
  const setupEvents = function () {

    // Resize event
    $win.on('resize', function () {
      onResize();
    });


    // Scrollme ;) scroll
    $('.scrollme').on('click', function () {
      //goTo(this, 'smooth', getOffset(-40));
      window.scrollBy({ top: window.innerHeight - getOffset(), behavior: 'smooth' });
      return false;
    });



    // Go to top scroll
    $goup.on('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return false;
    });

    // Tooltips
    /*$( '[data-toggle="tooltip"]' ).tooltip( {
      animated: 'fade'
    } );*/

    // Popovers
    //$( '[data-toggle="popover"]' ).popover();

    // Fetch all the forms we want to apply custom validation styles to
    $doc.on('submit', '.needs-validation', function (e) {
      if (!this.checkValidity()) {
        e.preventDefault();
        e.stopPropagation();
        const el = document.querySelector('.needs-validation :invalid');
        if (el) {
          goTo(el, 'smooth', getOffset(100), function () {
            el.focus();
          });
        }
      }
      $(this).addClass('was-validated');
    });


  }


  /**
   * Position and Fade In image thumbnails after load complete
   */
  const preloadThumbs = function () {
    $(".img-cover.fade:not(.show),.img-contain.fade:not(.show),.img-fluid.fade:not(.show)").on("load", function () {
      $(this).addClass('show');
    }).each(function () {
      // forze for cached images
      if (this.complete) $(this).trigger("load");
    });
  }

  /**
   * Display header shadow on scroll
   */
  const stickyShadow = function () {

    const header = document.getElementById("masthead");
    const scrollTop = document.getElementById("sticky-scroll");

    if (header) {

      const intercept = document.createElement("div");
      intercept.setAttribute("data-observer-intercept", "");
      intercept.setAttribute("class", "header-observer");

      header.before(intercept);

      const observer = new IntersectionObserver(([entry]) => {
        header.classList.toggle("active", !entry.isIntersecting);
        scrollTop.classList.toggle("off", entry.isIntersecting);
      });

      observer.observe(intercept);

    }
  }

  /**
   * Smoke effect
   */
  function initSmoke() {
    const options = {};
    if (themeData.smokeImg) {
      options.smokeImg = themeData.smokeImg;
    }
    if (themeData.smokeColor) {
      options.color = parseInt('0x' + themeData.smokeColor.slice(1));
    }
    if (themeData.smokeDensity) {
      options.density = themeData.smokeDensity;
    }
    if (themeData.smokeOpacity != 0) {
      const smoke = new Smoke(options);
      smoke.update();
    }
  }

  /**
   * 
   * Lenis SmoothScroll raf
   */
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  /**
   * Lenis SmothScroll init
   */
  function smoothScroll() {

    if (isMobile.any()) {
      return false;
    }

    lenis = new Lenis();

    /*
    lenis.on('scroll', (e) => {
      console.log(e)
    })
    */

    requestAnimationFrame(raf);

  }

  /** 
   * GSAP Animations
   */
  function initAnimations() {

    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

    const home_logo = document.querySelector('.lab-sek-home-logo');

    // Home logo

    if (home_logo) {

      const logo_anim = gsap.from(home_logo, {
        scale: 3,
        opacity: 0,
        ease: "power4",
        duration: 3,
        onUpdate: () => {
          const blur = logo_anim.duration() * 4 - logo_anim.time() * 4;
          gsap.set(home_logo, { webkitFilter: "blur(" + blur + "px)", filter: "blur(" + blur + "px)" });
        }
      });

    }


    // Intro text
    if (!isMobile.any()) {

      const intro_text = document.querySelector('.lab-sek-intro-text');
      const intro_paragraphs = intro_text ? intro_text.querySelectorAll('p') : null;


      if (intro_text) {
        gsap.from(intro_paragraphs, {
          scrollTrigger: {
            trigger: intro_text,
            start: "top 75%",
            end: "bottom 25%",
            scrub: 1,
            /*toggleActions: "play pause play none",*/
            markers: false,
          },
          scale: 1.25,
          opacity: 0,
          ease: "power4",
          duration: 1,
          stagger: 0.2
        });

      }

    }

    // Instruments block

    gsap.utils.toArray(".instrument-item").forEach((section, index) => {

      const author = section.querySelector(".entry-author-inner");
      const order = section.querySelector(".entry-order-inner");
      const title = section.querySelector(".entry-title-inner");
      const summary = section.querySelector(".entry-summary");
      const footer = section.querySelector(".entry-footer .btn");
      const img = section.querySelector(".entry-image");

      const title_split = title ? new SplitType(title, { types: 'lines' }) : null;
      const title_lines = title ? title.querySelectorAll('.line') : null;

      let tl;

      if (section.classList.contains('instrument-item-grid')) {

        if (isMobile.any()) {

          tl = gsap.timeline({
            scrollTrigger: {
              trigger: section,
              markers: false,
              start: "top 90%",
              end: "bottom 90%",
              scrub: 1,
            },
            defaults: { ease: "power4" }
          });
        } else {
          tl = gsap.timeline({
            scrollTrigger: {
              trigger: section,
              markers: false,
              start: "top 80%",
              end: "bottom 80%",
              scrub: 1.5
            },
            defaults: { ease: "power4" }
          });
        }

      } else {
        tl = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            start: "top 75%",
            end: "bottom 25%",
            toggleActions: "play pause play none",
            markers: false,
          },
          defaults: { ease: "power4" }
        });
      }


      let delay = 0;

      if (author) {
        tl.from(author, {
          opacity: 0,
          y: 45,
        }, delay)
        delay += .1;
      }

      if (order) {
        tl.from(order, {
          y: -100,
          opacity: 0,
        }, delay)
        delay += .15;
      }

      if (title_lines) {
        tl.from(title_lines, {
          rotateY: -45,
          opacity: 0,
          stagger: 0.2,
          transformOrigin: '0 50%'
        }, delay);
        delay += .25;
      }

      if (summary) {
        tl.from(summary, {
          y: -30,
          opacity: 0,
        }, delay)
        delay += .15;
      }

      if (img) {
        tl.from(img, {
          opacity: 0,
          scale: .9,
        }, delay)
        delay += .15;
      }

      if (footer) {
        tl.from(footer, {
          opacity: 0,
          scale: 1.25,
          transformOrigin: '0% 50%'
        }, delay)
      }

    });

    gsap.utils.toArray(".instrument-item-single .instrument-header").forEach((section, index) => {


      const author_single = section.querySelector(".entry-author-inner");
      const order_single = section.querySelector(".entry-order-inner");
      const title_single = section.querySelector(".entry-title-inner");

      const title_split = title_single ? new SplitType(title_single, { types: 'lines' }) : null;
      const lines_single = title_single ? title_single.querySelectorAll('.line') : null;

      let tl_single;
      tl_single = gsap.timeline({
        defaults: { ease: "power4", duration: 2 }
      });

      let delay = 0;

      if (author_single) {
        tl_single.from(author_single, {
          opacity: 0,
          y: 45,
        }, delay)
        delay += .1;
      }

      if (order_single) {
        tl_single.from(order_single, {
          y: -100,
          opacity: 0,
        }, delay)
        delay += .15;
      }

      if (lines_single) {
        tl_single.from(lines_single, {
          rotateY: -45,
          opacity: 0,
          stagger: 0.2,
          transformOrigin: '0 50%'
        }, delay);
      }

    });





    // Instrument heading block

    gsap.utils.toArray(".lab-sek-instrument-heading-block").forEach((section, index) => {

      const author_heading = section.querySelector(".entry-author-inner");
      const order_heading = section.querySelector(".entry-order-inner");
      const title_heading = section.querySelector(".entry-title-inner");
      const border_heading = section.querySelector(".with-border");
      const title_split = title_heading ? new SplitType(title_heading, { types: 'lines' }) : null;
      const lines_heading = title_heading ? title_heading.querySelectorAll('.line') : null;

      let tl_block;

      if (isMobile.any()) {

        tl_block = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            /*start: "top 75%",
            end: "bottom 25%",
            toggleActions: "play pause play none",*/
            markers: false,
            start: "top 90%",
            end: "bottom 90%",
            scrub: 1,
          },
          defaults: { ease: "power4" }
        });
      } else {
        tl_block = gsap.timeline({
          scrollTrigger: {
            trigger: section,
            /*start: "top 75%",
            end: "bottom 25%",
            toggleActions: "play pause play none",*/
            markers: false,
            start: "top 80%",
            end: "bottom 80%",
            scrub: 1.5
          },
          defaults: { ease: "power4" }
        });
      }


      let delay = 0;

      if (author_heading) {
        tl_block.from(author_heading, {
          opacity: 0,
          y: 45,
        }, delay)
        delay += .1;
      }

      if (order_heading) {
        tl_block.from(order_heading, {
          y: -100,
          opacity: 0,
        }, delay)
        delay += .15;
      }

      if (lines_heading) {
        tl_block.from(lines_heading, {
          rotateY: -45,
          opacity: 0,
          stagger: 0.2,
          transformOrigin: '0 50%'
        }, delay);
        delay += .15;
      }

      if (border_heading) {
        tl_block.from(border_heading, {
          scaleX: 0,
          opacity: 0,
          transformOrigin: '0 50%'
        }, delay)

      }

    });

    // Related 
    gsap.utils.toArray(".related-posts-title").forEach((section, index) => {

      const split = new SplitType(section, { types: 'lines' })
      const lines = section.querySelectorAll('.line');

      let tl_related;
      tl_related = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          /*start: "top 75%",
          end: "bottom 25%",
          toggleActions: "play pause play none",*/
          markers: false,
          start: "top 80%",
          end: "bottom 80%",
          scrub: 1.5
        },
        defaults: { ease: "power4" }
      });

      if (lines) {
        tl_related.from(lines, {
          rotateY: -45,
          opacity: 0,
          stagger: 0.2,
          transformOrigin: '0 50%'
        });
      }

    });



    // Full page scroll progress

    let body = document.body;
    gsap.to("body", {
      scrollTrigger: {
        trigger: "body",
        start: "top 100%",
        end: "bottom 0%",
        scrub: 1,
        markers: false,
        onUpdate: (self) => {
          body.style.setProperty("--progress", self.progress);
        }
      }
    });



    // Grid scroll
    const listItems = Array.from(document.getElementsByClassName("grid-item"));
    listItems.forEach((item, index) => {
      // gsap.set(item, { opacity: 0, y: -100, scale: 0.75 });
      gsap.from(item, {
        y: 30,
        opacity: 0,
        scale: .9,
        scrollTrigger: {
          trigger: item,
          start: "top 90%",
          end: "bottom 10%",
          // toggleActions: "${onEnter} ${onLeave} ${onEnterBack} ${onLeaveBack}"
          // options: play, pause, resume, reset, restart, complete, reverse, and none
          toggleActions: "play reverse play reverse",
          markers: false
        }
      });
    });


  }


  function initVideoPlayer() {

    $players = $('.lab-sek-player-play');

    $players.each(function (i, e) {

      const $play = $(this);
      const $player = $('#' + $play.data('player'));

      $videos[$play.data('player')] = new Plyr('#' + $play.data('player') + ' .lab-sek-plyr', {
        captions: { active: false }
      });

      $videos[$play.data('player')].on('ended', event => {
        console.log('END', this, event, event.target);
        const $pl = $(this);
        const $py = $('#' + $pl.data('player'));
        $py.removeClass('on').addClass('off');
      });

      $play.on('click', function (e) {
        $player.removeClass('off').addClass('on');
        $videos[$play.data('player')].play();
      });

    });

    resizePlayers();

  }

  function resizePlayers() {

    if (!$players || !$players.length) {
      return false;
    }

    $players.each(function (i, e) {

      const $play = $(this);
      const $player = $('#' + $play.data('player'));
      let ratio = 16 / 9;
      let height = $player.height();
      let width = $player.width();

      let playerRatio = width / height;
      let margin = {
        x: 0,
        y: 0
      };

      if (playerRatio > ratio) {
        // We need to move the player up
        let newHeight = Math.ceil((width / ratio - height) / 2);
        margin.y = -newHeight + 'px';
      } else if (playerRatio < ratio) {
        // We need more with
        let newWidth = height * ratio;
        margin.x = Math.floor((newWidth - width) / -2) + 'px';
      }

      $player.find('.plyr__video-wrapper').css({ marginLeft: margin.x, marginRight: margin.x, marginTop: margin.y });

    });


  }

  /**
   * On resize event handler (debounced)
   */
  const onResize = debounce(() => {

    resizePlayers();

  }, 10, false)

  /**
   * Initialize application
   */
  $(function () {
    console.log('🚀 Laboratorium Sekretua is ready!');
    if (isMobile.any()) $body.addClass('device-touch');
    setupMenu();
    setupEvents();
    preloadThumbs();
    smoothScroll();
    stickyShadow();
    onResize();
    initSmoke();
    initAnimations();
    initVideoPlayer();
  })

})(jQuery, typeof labSekData !== 'undefined' ? labSekData : {});
